<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-dad">
    <main class="tpl-dad__card">
      <header class="tpl-dad__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-dad__logo" />
      </header>
      <hr class="tpl-dad__divider" />

      <div v-if="showHero" class="tpl-dad__hero">
        <div class="tpl-dad__hero-block">
          <h1 class="tpl-dad__hero-title">{{ quiz.title }}</h1>
          <p v-if="quiz.sub_title" class="tpl-dad__hero-sub">{{ quiz.sub_title }}</p>
        </div>
        <p class="tpl-dad__timer"><span aria-hidden="true">&#128337;</span> {{ progress.total }} min!</p>
      </div>

      <div class="tpl-dad__progress-track">
        <div
          class="tpl-dad__progress-fill"
          :style="{
            width: (isGate ? 100 : (progress.current / Math.max(progress.total + 1, 1)) * 100) + '%',
          }"
        ></div>
      </div>

      <slot />

      <footer class="tpl-dad__footer">
        <p v-if="quiz.privacy_url">
          <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-dad__footer-legal">
          © {{ quiz.legal_name }}<template v-if="quiz.legal_id"> - {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-dad__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
